import React from 'react'
import {Grid} from '@material-ui/core';
import PropTypes from 'prop-types'
import InfoDataElement from './InfoDataElement';
import {LABELS as ProcedureStatusLabels} from 'constants/ProcedureStatus';
import moment from 'moment';
import DateFormats from "constants/DateFormats";
import {PrimaryTenderVariantTr} from "constants/PrimaryTenderVariant";

function InfoData(
	{
		contractor,
		headerData
	}) {
	if (!headerData.authorUser) return '';

	return (
		<Grid
			container
			direction='column'
		>
			<InfoDataElement trKey={'registering_person'} value={`${headerData.authorUser.firstName} ${headerData.authorUser.lastName}`} />
			<InfoDataElement trKey={'organizational_unit'} value={headerData.organization.name} />
			<InfoDataElement trKey={'demand_type'} value={headerData.procedureTypeTr} />
			<InfoDataElement trKey={'demand_realization_type'} value={headerData.demandRealizationTypeTr} />
			{!!headerData.primaryTenderVariant && <InfoDataElement trKey={'primary_tender_variant'} value={PrimaryTenderVariantTr[headerData.primaryTenderVariant]} />}
			<InfoDataElement trKey={'demand_status'} value={ProcedureStatusLabels[headerData.status]} />
			{headerData.procedureStartDate && <InfoDataElement trKey={'procedure_start_date'} value={moment(headerData.procedureStartDate).format(DateFormats.DATETIME_FORMAT)} />}
		</Grid>
	)
}

InfoData.propTypes = {
	type: PropTypes.string,
	procedure: PropTypes.string,
	status: PropTypes.string,
	number: PropTypes.string,
	contractor: PropTypes.bool.isRequired
}

InfoData.defaultProps = {
}

export default InfoData;
